var map = {
	"./Dandelion_greens.png": 87562,
	"./MSG_rich_foods.png": 73569,
	"./Nectarines.png": 52019,
	"./alcohol.png": 14073,
	"./algal_oil.png": 87053,
	"./almonds.png": 89489,
	"./amaranth.png": 93509,
	"./anchovies.png": 74669,
	"./apples.png": 79489,
	"./apricots.png": 11930,
	"./artichokes.png": 55197,
	"./arugula.png": 4454,
	"./asparagus.png": 63537,
	"./avocadoes.png": 82775,
	"./bacon.png": 84862,
	"./baked_beans.png": 45454,
	"./balsamic_vinegar.png": 24193,
	"./bananas.png": 62965,
	"./barley.png": 65629,
	"./barley_flakes.png": 23080,
	"./barley_rusks.png": 92114,
	"./basil.png": 56361,
	"./beef.png": 79729,
	"./beet_greens.png": 67385,
	"./beetroots.png": 48207,
	"./beets.png": 68121,
	"./bell_peppers.png": 43919,
	"./berries.png": 74840,
	"./black_grapes.png": 28166,
	"./blackberries.png": 61704,
	"./blackcurrants.png": 23674,
	"./blueberries.png": 29343,
	"./brazil_nuts.png": 46155,
	"./broccoli.png": 20426,
	"./brown_beans.png": 52679,
	"./brussel_sprouts.png": 48737,
	"./bulgur.png": 18262,
	"./burdock.png": 74847,
	"./burger_and_fries.png": 30025,
	"./buttermilk.png": 76647,
	"./cabbage.png": 4330,
	"./calamari.png": 8409,
	"./canned_soup.png": 84218,
	"./canned_tomatoes.png": 87493,
	"./canola_oil.png": 27155,
	"./cantaloupe.png": 88185,
	"./capers.png": 37827,
	"./carrots.png": 85467,
	"./cauliflower.png": 74935,
	"./celery.png": 11769,
	"./charred_meats.png": 30640,
	"./cherries.png": 24948,
	"./chia_seeds.png": 28624,
	"./chicken.png": 36221,
	"./chickery_roots.png": 46045,
	"./chickpeas.png": 86788,
	"./chicory.png": 53617,
	"./chips.png": 7836,
	"./cinnamon.png": 67993,
	"./cloudberries.png": 15078,
	"./cocoa.png": 39495,
	"./coconut.png": 18219,
	"./coconut_flour.png": 91751,
	"./cod.png": 65011,
	"./coffee.png": 31860,
	"./coffee_creamer.png": 61547,
	"./commercial_protein_bars.png": 96615,
	"./concord_grapes.png": 19569,
	"./cookies.png": 15493,
	"./corn_syrup.png": 99224,
	"./corned_beef.png": 19421,
	"./couscous.png": 81122,
	"./cranberries.png": 47446,
	"./cucumbers.png": 26301,
	"./cumin.png": 28323,
	"./daikon_radishes.png": 81080,
	"./dandelion.png": 72354,
	"./dark_chocolate_over_80.png": 36875,
	"./deep_fried_foods.png": 20229,
	"./default_food.png": 28032,
	"./deli_meats.png": 95559,
	"./diet_sodas.png": 25344,
	"./dill.png": 9840,
	"./dried_dates.png": 72198,
	"./dried_figs.png": 49591,
	"./dried_fruits.png": 48851,
	"./egg_pasta.png": 86878,
	"./eggplant.png": 57841,
	"./eggs.png": 9977,
	"./elk.png": 90349,
	"./endive.png": 20541,
	"./energy_drinks.png": 98956,
	"./extra_virgin_olive_oil.png": 71417,
	"./fast_foods.png": 23837,
	"./fennel.png": 48085,
	"./fermented_fish.png": 8508,
	"./fermented_milk.png": 45939,
	"./feta_cheese.png": 11007,
	"./figs.png": 50494,
	"./filter_organic_coffee.png": 77334,
	"./fish.png": 26622,
	"./fish_n_chips.png": 8591,
	"./flax.png": 54841,
	"./flaxseed_oil.png": 93357,
	"./flaxseeds.png": 98106,
	"./fruit_juices.png": 72137,
	"./fruit_juices_in_excess.png": 13576,
	"./garlic.png": 3250,
	"./ginger_roots.png": 54513,
	"./grapefruit.png": 35694,
	"./graviera.png": 46162,
	"./greek_yogurt.png": 24551,
	"./green_beans.png": 40813,
	"./green_peas.png": 80737,
	"./green_tea.png": 95664,
	"./ground_beef.png": 27327,
	"./hazelnuts.png": 44751,
	"./hemp_seeds.png": 42973,
	"./herring.png": 10764,
	"./hibiscus_tea.png": 95397,
	"./high_fructose_foods.png": 29462,
	"./hijiki.png": 28223,
	"./honey.png": 4805,
	"./horseradish.png": 24118,
	"./jerusalem_artichokes.png": 5599,
	"./kale.png": 73952,
	"./kangaroo.png": 87547,
	"./kefir.png": 36925,
	"./kelp.png": 13706,
	"./kiwi.png": 30108,
	"./kombu.png": 23416,
	"./kombucha.png": 75773,
	"./konjac.png": 32916,
	"./lamb.png": 3045,
	"./leek.png": 85189,
	"./lemon_tea.png": 65984,
	"./lemons.png": 15377,
	"./lentils.png": 97178,
	"./lingonberries.png": 99271,
	"./low_fat_cheese.png": 31967,
	"./low_fat_milk.png": 26616,
	"./low_sodium_salt.png": 76636,
	"./macadamia_nut_butter.png": 96506,
	"./mackerel.png": 99615,
	"./mangoes.png": 88405,
	"./margarine.png": 91041,
	"./microwave_meals.png": 39316,
	"./mint.png": 97161,
	"./mitzithra.png": 42845,
	"./mozzarella.png": 5264,
	"./muesli.png": 78335,
	"./mulberries.png": 99296,
	"./mushrooms.png": 94820,
	"./mustard.png": 77622,
	"./nori.png": 9618,
	"./oat.png": 85148,
	"./oat_bran_rusks.png": 16411,
	"./oatmeal.png": 18649,
	"./octopus.png": 73760,
	"./okra.png": 28348,
	"./olives.png": 9698,
	"./onions.png": 34935,
	"./oranges.png": 58237,
	"./oregano.png": 8906,
	"./packaged_sweets.png": 32745,
	"./palm_oil.png": 77316,
	"./parmesan.png": 2581,
	"./parsley.png": 37604,
	"./parsnip.png": 82824,
	"./pasta.png": 68027,
	"./peaches.png": 88560,
	"./pears.png": 96270,
	"./peas.png": 39269,
	"./pecans.png": 3478,
	"./peppers.png": 33044,
	"./persimmons.png": 15624,
	"./phyllo.png": 76946,
	"./pine_nuts.png": 91137,
	"./pistachios.png": 62843,
	"./pita_bread.png": 24653,
	"./pizzas.png": 4078,
	"./plantains.png": 5367,
	"./plums.png": 81036,
	"./pomegranate.png": 57779,
	"./pork.png": 29798,
	"./potato_crisps.png": 18795,
	"./potatoes.png": 96185,
	"./potatoes_boiled.png": 24145,
	"./processed_meats.png": 91996,
	"./prunes.png": 99192,
	"./psyllium_seed.png": 69148,
	"./pumpkin_seeds.png": 28218,
	"./quinoa.png": 54616,
	"./rabbit.png": 71902,
	"./radish.png": 62775,
	"./raspberries.png": 86759,
	"./red_kidney_beans.png": 1361,
	"./red_meat_in_excess.png": 81612,
	"./red_onions.png": 95581,
	"./red_wine.png": 88829,
	"./red_wine_vinegar.png": 9418,
	"./redcurrants.png": 58904,
	"./refined_grains.png": 43114,
	"./reindeer.png": 25535,
	"./rice.png": 29919,
	"./ricotta_cheese.png": 33571,
	"./romaine_lettuce.png": 12660,
	"./rye.png": 21730,
	"./rye_bread.png": 36972,
	"./salad_dressings.png": 89815,
	"./salami.png": 41772,
	"./salmon.png": 53333,
	"./sardines.png": 96831,
	"./seaweeds.png": 10224,
	"./seeds_oil.png": 49877,
	"./sesame_seeds.png": 3576,
	"./shrimp.png": 33453,
	"./snow_peas.png": 47524,
	"./soy_based_meat.png": 77825,
	"./soy_yogurts.png": 17029,
	"./soybean.png": 5213,
	"./soybean_oil.png": 62007,
	"./soymilk.png": 53050,
	"./spearmint_tea.png": 55242,
	"./spinach.png": 93979,
	"./split_peas.png": 59765,
	"./spring_onions.png": 92284,
	"./strawberries.png": 94473,
	"./sugar_peas.png": 39253,
	"./sugary_beverages.png": 10297,
	"./sugary_cereals.png": 56763,
	"./sundried_tomatoes.png": 50307,
	"./sunflower_oil.png": 59484,
	"./sweet_potatoes.png": 45541,
	"./table_salt.png": 47002,
	"./tahini.png": 73861,
	"./tangerines.png": 24800,
	"./tap_water.png": 15085,
	"./tomato_paste.png": 34173,
	"./tomatoes.png": 18802,
	"./trout.png": 14248,
	"./tuna.png": 475,
	"./turkey.png": 86296,
	"./turnip.png": 88140,
	"./umibudo.png": 92478,
	"./veal.png": 75535,
	"./vinaigrette.png": 15053,
	"./wakame.png": 61651,
	"./walnuts.png": 23045,
	"./watermelon.png": 65239,
	"./wheat_bran.png": 33742,
	"./wheat_bread.png": 40748,
	"./white_beans.png": 28909,
	"./white_bread.png": 9729,
	"./white_pasta.png": 55435,
	"./white_peaches.png": 93501,
	"./white_potatoes.png": 22413,
	"./white_sugar.png": 60797,
	"./whole_grain_bread.png": 29794,
	"./whole_grain_rye.png": 68773,
	"./wild_caught_tuna.png": 15413,
	"./wild_rice.png": 96434,
	"./yacon.png": 39323,
	"./yams.png": 98923,
	"./yellow_beans.png": 30692,
	"./yellow_split_pea.png": 38199,
	"./yogurt.png": 37659,
	"./zucchini.png": 22704
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 81681;
module.exports = webpackAsyncContext;